import { useEffect, useRef } from "react";
import { Breakpoint, useMediaQuery } from "@stubhub/broadway-providers";
import { useSimpleFeatureTernary } from "@viagogo/feature";
import { FeatureSetEnum } from "src/shared/constants/FeatureSetEnum";
import { useAppContext } from "src/shared/context/AppContext";
import { CarouselGenreFilter } from "../tm-home-move-filters-out-of-header/CarouselGenreFilter";
import { PageFiltersOnHome } from "../tm-home-move-filters-out-of-header/PageFiltersOnHome";

interface Props {
  selectedCarouselGenre: number;
  setSelectedCarouselGenre: (genre: number) => void;
  disableFilterFocusMode?: boolean;
}
export const FilterSection = ({ selectedCarouselGenre, setSelectedCarouselGenre, disableFilterFocusMode }: Props) => {
  const appContext = useAppContext();
  const isTabletOrLarger = useMediaQuery(Breakpoint.Tablet);
  const isMobile = !isTabletOrLarger;
  const filterSectionRef = useRef<HTMLDivElement>(null);
  const prevGenreRef = useRef(selectedCarouselGenre);

  const isFilterFocusMode = useSimpleFeatureTernary(
    FeatureSetEnum.CXWD_HomeFilterFocusMode,
    false,
    true,
    () => selectedCarouselGenre !== 0,
  );

  useEffect(() => {
    if (isFilterFocusMode && !disableFilterFocusMode && prevGenreRef.current === 0 && selectedCarouselGenre !== 0) {
      filterSectionRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    prevGenreRef.current = selectedCarouselGenre;
  }, [selectedCarouselGenre, isFilterFocusMode, disableFilterFocusMode]);

  return (
    <div ref={filterSectionRef}>
      {(!isMobile || appContext.isNativeApp) && (
        <PageFiltersOnHome
          selectedCarouselGenre={selectedCarouselGenre}
          setSelectedCarouselGenre={setSelectedCarouselGenre}
        />
      )}
      {isMobile && (
        <CarouselGenreFilter selectedTlc={selectedCarouselGenre} setSelectedTlc={setSelectedCarouselGenre} />
      )}
    </div>
  );
};
